import type { FC } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import styles from "./SouhlAdminSidebar.module.scss"

type SouhlAdminSidebarProps = {
	isOpen: boolean
}

const SouhlAdminSidebar: FC<SouhlAdminSidebarProps> = ({ isOpen }) => {
	const navigate = useNavigate()
	const location = useLocation()

	// 現在のパスを判定してアクティブな状態を管理
	const isCompaniesActive = location.pathname === "/souhl_admin"
	const isKnownIssuesActive = location.pathname.startsWith(
		"/souhl_admin/known_issues"
	)
	const isUnknownIssueLogsActive = location.pathname.startsWith(
		"/souhl_admin/unknown_issue_logs"
	)
	const isTaigaActive = location.pathname.startsWith("/souhl_admin/taiga")

	const handleCompanyClick = () => {
		navigate("/souhl_admin")
	}

	const handleKnownIssuesClick = () => {
		navigate("/souhl_admin/known_issues")
	}

	const handleUnknownIssueLogsClick = () => {
		navigate("/souhl_admin/unknown_issue_logs")
	}

	const handleTaigaClick = () => {
		navigate("/souhl_admin/taiga")
	}

	return (
		<div className={`${styles.sidebar} ${!isOpen ? styles.collapsed : ""}`}>
			<div className={styles.header}>
				<h1 className={styles.title}>{isOpen ? "SOUHL ADMIN" : "S"}</h1>
			</div>

			<nav className={styles.navigation}>
				<ul className={styles.navList}>
					<li
						className={`${styles.navItem} ${
							isCompaniesActive ? styles.active : ""
						}`}
						onClick={handleCompanyClick}
						title="会社"
					>
						<span className={styles.navText}>{isOpen ? "会社" : "会"}</span>
					</li>
					<li
						className={`${styles.navItem} ${
							isKnownIssuesActive ? styles.active : ""
						}`}
						onClick={handleKnownIssuesClick}
						title="Known Issues"
					>
						<span className={styles.navText}>
							{isOpen ? "Known Issues" : "KI"}
						</span>
					</li>
					<li
						className={`${styles.navItem} ${
							isUnknownIssueLogsActive ? styles.active : ""
						}`}
						onClick={handleUnknownIssueLogsClick}
						title="Unknown Issue Logs"
					>
						<span className={styles.navText}>
							{isOpen ? "Unknown Issue Logs" : "UL"}
						</span>
					</li>
					<li
						className={`${styles.navItem} ${
							isTaigaActive ? styles.active : ""
						}`}
						onClick={handleTaigaClick}
						title="Taiga"
					>
						<span className={styles.navText}>{isOpen ? "Taiga" : "TG"}</span>
					</li>
				</ul>
			</nav>
		</div>
	)
}

export default SouhlAdminSidebar
